import { Badge, Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/** Map backend sync state → DS Badge tone (mockup STATE_TONE). */
const STATE_TONE: Record<string, 'ds-success' | 'ds-warning' | 'ds-error' | 'ds-neutral'> = {
  SYNCHRONIZED: 'ds-success',
  SYNCHRONIZING: 'ds-warning',
  FAILED: 'ds-error',
  STOPPED: 'ds-error',
  UNPROCESSABLE: 'ds-error',
};

interface Props {
  statusKey: string;
}

/**
 * DS status badge for sync states — design-guidelines.md §4 Badge
 * (soft bg + color, 6px leading dot). Label reuses existing
 * `common.state.*` i18n keys (no new keys, identical text).
 */
const SyncStatusBadge = ({ statusKey }: Props) => {
  const { t } = useTranslation();
  if (!statusKey) return null;
  const variant = STATE_TONE[statusKey] ?? 'ds-neutral';

  return (
    // Soft dot-pill (mockup): pill radius + leading dot + tinted bg/color.
    // Label = real `common.state.*` value (LOCKED: text unchanged). NOTE: those
    // i18n values are ALL-CAPS (e.g. "SYNCHRONIZED"), so CSS cannot down-case to
    // mockup Title-case ("Synchronized") without editing source text — see report.
    <Badge px={2.5} borderRadius='full' variant={variant}>
      <Box as='span' flexShrink={0} w='6px' h='6px' mr={1} bg='currentColor' borderRadius='full' />
      {t(`common.state.${statusKey}`)}
    </Badge>
  );
};

export default SyncStatusBadge;
